export const callbackTableColumns = [
  {

    title: "Product",
    dataIndex: "productFamily",
    key: "productFamily",
    width: "12%"
  },
  {
    title: "Customer Name",
    dataIndex: "customerName",
    key: "customerName",
    width: "12%"
  },
  {
    title: "Customer Email",
    dataIndex: "customerAdobeId",
    key: "customerAdobeId",
    width: "12%"
  },
  {
    title: "Case Id",
    dataIndex: "caseId",
    key: "caseId",
    width: "8%"
  },
  {
    title: "OrgId",
    dataIndex: "orgId",
    key: "orgId",
    width: "10%"
  },
  {
    title: "Phone Number",
    dataIndex: "phoneNumber",
    key: "phoneNumber",
    width: "10%"
  },
  {
    title: "Customer Timezone",
    dataIndex: "timezone",
    key: "timezone",
    width: "12%"
  },
  {
    title: "Request Time",
    dataIndex: "callbackTimeEpoch",
    key: "callbackTimeEpoch",
    width: "12%"
  },
  {
    title: "Accept Time",
    dataIndex: "acceptTimeEpoch",
    key: "acceptTimeEpoch",
    width: "12%"
  },
  {
    title: "Dial Time",
    dataIndex: "dialTimeEpoch",
    key: "dialTimeEpoch",
    width: "12%"
  },
  {
    title: "Callback Surface",
    dataIndex: "callbackSurface",
    key: "callbackSurface",
    width: "12%"
  },
  // {

  //   title: "Schedule Time",
  //   dataIndex: "callbackScheduleTimeEpoch",
  //   key: "callbackScheduleTimeEpoch",
  //    width: "15%"
  // },
  // {
  //   title: "Timezone",
  //   dataIndex: "timezone",
  //   key: "timezone",
  //   // width: "15%"
  // },
  // {
  //   title: "Notes",
  //   dataIndex: "notes",
  //   key: "notes",
  //   // width: "15%"
  // },
 
  {
    title: "Status",
    dataIndex: "requestStatus",
    key: "requestStatus",
    width: "10%"
  },
  {
    title: "Call Attempts By",
    dataIndex: "userLdap",
    key: "userLdap",
    width: "12%"
  },
  {
    title: "Call Attempts",
    dataIndex: "connectContacts",
    key: "connectContacts",
    width: "12%"
  },
  {
    title: "Contact ID",
    dataIndex: "contactId",
    key: "contactId",
    width: "8%"
  },
  {
    title: "Type",
    dataIndex: "callbackType",
    key: "callbackType",
    width: "13%"
  },
  {
    title:"Callback Scheduled Time",
    dataIndex:"callbackScheduleTime",
    key:"callbackScheduleTime",
    width:"13%"
  },
  // {
  //     title: "Action",
  //     dataIndex: "actions",
  //     key: "actions",
  //     // width: "15%"

  // }
];

export const callbackStatus = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "Pending",
    id: "PENDING",
  },
  {
    name: "In Progress",
    id: "INPROGRESS",
  },
  {
    name: "Complete",
    id: "COMPLETE",
  },
  {
    name: "Failed",
    id: "FAILED",
  },
  {
    name: "New",
    id: "NEW",
  },
  {
    name:"Cancelled",
    id:"CANCELLED"
  }
];

  // Define color map once, outside the function
  export const STATUS_COLORS: Record<string, string> = {
    PENDING: "#FFA500",
    IN_PROGRESS: "#F68511",
    INPROGRESS: "#F68511",
    COMPLETE: "#008000", 
    FAILED: "#FF0000",
    NEW: "#147AF3",
    CANCELLED: "#808080",
    ALL: "",
  };
export const callbackTypes = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "Immediate",
    id: "IMMEDIATE",
  },
  {
    name: "Scheduled",
    id: "SCHEDULED",
  },
];

export const callbackSurface = [
  {
    name: "All",
    id: "ALL",
  },
  {
    name: "EXL-Case Detail",
    id: "EXL-Case Detail",
  },
  {
    name: "EXL-Home",
    id: "EXL-Home",
  },
];

